<template>
	<div id="app" ontouchstart>
		<router-view v-if="isRouterAlive"></router-view>
	</div>
</template>

<script>
import { AddressParameter } from '../../utils/index'
export default {
	provide() {
		return {
			reload: this.reload,
		}
	},
	data() {
		return {
			isRouterAlive: true,
		}
	},
	filters: {},
	computed: {},
	watch: {},
	methods:{
		computed(){
			const desW = 1920
      const devW = document.documentElement.clientWidth
      if (devW > 1280) {
        document.documentElement.style.fontSize = devW / desW * 75 + 'px'
      } else {
        document.documentElement.style.fontSize = 50 + 'px'
      }
		}
	},
	created() {
		if (
			AddressParameter('appType') == 'null' ||
			AddressParameter('appType') == '0' ||
			AddressParameter('appType') == '3'
		) {
			this.$store.commit('replaceContentUpdate', '盘丝洞')
			this.$store.commit('replaceCoinContentUpdate', '盘币')
			this.$store.commit('replaceGainCoinContentUpdate', '盘豆')
		}
		
    this.computed()
    window.addEventListener('resize', this.computed, false)

	},
}
</script>

<style lang="scss" scoped>
#app {
	position: absolute;
	width: 100%;
	min-height: 100vh;
	height: auto;
	background-color: rgba(0, 0, 0, 0);
}
.lx-toast {
	font-size: 30px;
}
</style>
